import { useState } from "preact/hooks"
import { FieldInputProps } from "react-final-form"
import { EyeHide, EyeShow } from "../icons/eye"
import { t } from "../hooks/translations"
import css from "../style.module.scss"

type PasswordFieldProps = {
  input: FieldInputProps<string, HTMLInputElement>
  id: string
  placeholder: string
  autoComplete?: string
  disabled?: boolean
}

export function PasswordField({
  input,
  id,
  placeholder,
  autoComplete = "current-password",
  disabled,
}: PasswordFieldProps) {
  const [revealed, setRevealed] = useState(false)
  const label = revealed ? t("hide_password") : t("show_password")
  const Icon = revealed ? EyeShow : EyeHide

  return (
    <div className={css["password-field"]}>
      <input
        {...input}
        className={css["signup-input"]}
        type={revealed ? "text" : "password"}
        autoComplete={autoComplete}
        placeholder={placeholder}
        id={id}
        disabled={disabled}
      />
      <button
        type="button"
        className={css["toggle-password"]}
        aria-label={label}
        onClick={() => setRevealed((value) => !value)}
      >
        <Icon className={css["eye-icon"]} />
      </button>
    </div>
  )
}
